// extracted by mini-css-extract-plugin
export default {"dash":"Dashboard_dash__JoHsY"};